/* ============================================================
   YOUCLIQ THEME — interactions
   ============================================================ */
(function () {
  'use strict';

  /* ---------- Mobile drawer ---------- */
  function initDrawer() {
    var drawer = document.querySelector('[data-mobile-drawer]');
    if (!drawer) return;
    document.querySelectorAll('[data-drawer-open]').forEach(function (b) {
      b.addEventListener('click', function () {
        drawer.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      });
    });
    drawer.querySelectorAll('[data-drawer-close]').forEach(function (b) {
      b.addEventListener('click', function () {
        drawer.classList.remove('is-open');
        document.body.style.overflow = '';
      });
    });
  }

  /* ---------- Product row carousels ---------- */
  function initCarousels() {
    document.querySelectorAll('[data-product-row]').forEach(function (row) {
      var track = row.querySelector('[data-row-track]');
      var prev = row.querySelector('[data-row-prev]');
      var next = row.querySelector('[data-row-next]');
      if (!track) return;
      var scrollBy = function () {
        var card = track.firstElementChild;
        return card ? card.getBoundingClientRect().width + 20 : 300;
      };
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -scrollBy() * 2, behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: scrollBy() * 2, behavior: 'smooth' }); });
    });
  }

  /* ---------- Hero slider ---------- */
  function initHero() {
    document.querySelectorAll('[data-hero]').forEach(function (hero) {
      var slides = hero.querySelectorAll('[data-hero-slide]');
      if (slides.length < 2) return;
      var idx = 0;
      var show = function (i) {
        slides.forEach(function (s, n) { s.style.display = n === i ? 'flex' : 'none'; });
      };
      show(0);
      var go = function (dir) { idx = (idx + dir + slides.length) % slides.length; show(idx); };
      var prev = hero.querySelector('[data-hero-prev]');
      var next = hero.querySelector('[data-hero-next]');
      if (prev) prev.addEventListener('click', function () { go(-1); });
      if (next) next.addEventListener('click', function () { go(1); });
      if (hero.hasAttribute('data-hero-autoplay')) {
        setInterval(function () { go(1); }, 6000);
      }
    });
  }

  /* ---------- Quantity selectors ---------- */
  function initQty() {
    document.querySelectorAll('[data-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      wrap.querySelector('[data-qty-minus]').addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 1; if (v > 1) input.value = v - 1;
        input.dispatchEvent(new Event('change'));
      });
      wrap.querySelector('[data-qty-plus]').addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 1; input.value = v + 1;
        input.dispatchEvent(new Event('change'));
      });
    });
  }

  /* ---------- Product gallery thumbs ---------- */
  function initGallery() {
    var gallery = document.querySelector('[data-gallery]');
    if (!gallery) return;
    var main = gallery.querySelector('[data-gallery-main]');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        var src = t.getAttribute('data-gallery-thumb');
        if (main && src) main.src = src;
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });
  }

  /* ---------- Variant selection ---------- */
  function initVariants() {
    var form = document.querySelector('.product__form');
    if (!form) return;
    var data = form.querySelector('[data-variant-json]');
    if (!data) return;
    var variants;
    try { variants = JSON.parse(data.textContent || '[]'); } catch (e) { return; }
    var selects = form.querySelectorAll('[data-option-select]');
    var idInput = form.querySelector('[data-variant-id]');
    var priceEl = document.querySelector('[data-price]');
    var compareEl = document.querySelector('[data-compare]');
    var atc = form.querySelector('[data-atc]');
    if (!selects.length) return;

    function update() {
      var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
      var match = variants.find(function (v) {
        return (v.options || []).every(function (o, i) { return o === chosen[i]; });
      });
      if (!match) return;
      if (idInput) idInput.value = match.id;
      if (priceEl) priceEl.textContent = formatMoney(match.price);
      if (compareEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          compareEl.textContent = formatMoney(match.compare_at_price);
          compareEl.style.display = '';
        } else { compareEl.style.display = 'none'; }
      }
      if (atc) {
        atc.disabled = !match.available;
        var label = atc.querySelector('span');
        if (label) label.textContent = match.available ? 'Add to Cart' : 'Sold Out';
      }
    }
    selects.forEach(function (s) { s.addEventListener('change', update); });
    update();
  }

  function formatMoney(cents) {
    return '₹' + (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  }

  /* ---------- AJAX add to cart ---------- */
  function initAddToCart() {
    document.querySelectorAll('.product__form').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        // Let "Buy Now" (name=checkout) and native fallback proceed normally
        if (e.submitter && e.submitter.name === 'checkout') return;
        if (!window.fetch) return;
        e.preventDefault();
        var btn = form.querySelector('[data-atc]');
        var label = btn ? btn.querySelector('span') : null;
        var original = label ? label.textContent : '';
        if (btn) { btn.disabled = true; if (label) label.textContent = 'Adding…'; }
        var fd = new FormData(form);
        fd.delete('checkout');
        fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd })
          .then(function (r) { return r.json(); })
          .then(function () { return fetch('/cart.js', { headers: { Accept: 'application/json' } }); })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            updateCartCount(cart.item_count);
            if (label) { label.textContent = 'Added ✓'; setTimeout(function () { label.textContent = original; btn.disabled = false; }, 1500); }
          })
          .catch(function () { if (btn) { btn.disabled = false; if (label) label.textContent = original; } form.submit(); });
      });
    });
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'grid' : 'none';
    });
  }

  /* ---------- Product tabs ---------- */
  function initTabs() {
    document.querySelectorAll('[data-tabs]').forEach(function (tabs) {
      var btns = tabs.querySelectorAll('[data-tab]');
      var panels = tabs.querySelectorAll('[data-panel]');
      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          var key = b.getAttribute('data-tab');
          btns.forEach(function (x) { x.classList.toggle('is-active', x === b); });
          panels.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-panel') === key); });
        });
      });
    });
  }

  /* ---------- Collection filter drawer (mobile) ---------- */
  function initFilterDrawer() {
    var panel = document.querySelector('[data-filter-panel]');
    if (!panel) return;
    var overlay = document.querySelector('.collection__overlay');
    function open() { panel.classList.add('is-open'); if (overlay) overlay.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    function close() { panel.classList.remove('is-open'); if (overlay) overlay.classList.remove('is-open'); document.body.style.overflow = ''; }
    document.querySelectorAll('[data-filter-open]').forEach(function (b) { b.addEventListener('click', open); });
    document.querySelectorAll('[data-filter-close]').forEach(function (b) { b.addEventListener('click', close); });
  }

  /* ---------- Recently viewed (localStorage) ---------- */
  function initRecentlyViewed() {
    var KEY = 'youcliq_recently_viewed';
    var list = [];
    try { list = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { list = []; }

    var currentEl = document.querySelector('[data-current-product]');
    if (currentEl) {
      var cur;
      try { cur = JSON.parse(currentEl.textContent); } catch (e) { cur = null; }
      if (cur && cur.handle) {
        list = list.filter(function (p) { return p.handle !== cur.handle; });
        list.unshift(cur);
        list = list.slice(0, 8);
        try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
      }
    }

    var wrap = document.querySelector('[data-recently-viewed]');
    var track = document.querySelector('[data-recently-track]');
    if (!wrap || !track) return;
    var currentHandle = null;
    if (currentEl) { try { currentHandle = JSON.parse(currentEl.textContent).handle; } catch (e) {} }
    var items = list.filter(function (p) { return p.handle !== currentHandle; }).slice(0, 4);
    if (!items.length) return;

    track.innerHTML = items.map(function (p) {
      var img = p.image ? '<img src="' + p.image + '" alt="" loading="lazy">' : '';
      var was = (p.compare && p.compare !== p.price) ? '<span class="price__was">' + p.compare + '</span>' : '';
      return '<div class="product-card">' +
        '<a href="' + p.url + '" class="product-card__media">' + img + '</a>' +
        '<div class="product-card__body">' +
        '<a href="' + p.url + '" class="product-card__title">' + p.title + '</a>' +
        '<div class="product-card__price">' + '<span class="price__now">' + p.price + '</span>' + was + '</div>' +
        '<a href="' + p.url + '" class="btn btn--dark btn--sm btn--full">View Details</a>' +
        '</div></div>';
    }).join('');
    wrap.hidden = false;
  }

  /* ---------- Video hero: lazy, in-view only, light ---------- */
  function initVideoHero() {
    var heroes = document.querySelectorAll('[data-video-hero]');
    if (!heroes.length) return;

    // Respect the user's device & preferences — keep it light.
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var small = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
    var saveData = navigator.connection && (navigator.connection.saveData ||
                   /2g/.test(navigator.connection.effectiveType || ''));
    var allowVideo = !reduce && !small && !saveData;

    heroes.forEach(function (hero) {
      var video = hero.querySelector('[data-bg-video]');

      if (!('IntersectionObserver' in window)) { hero.classList.add('is-active'); return; }

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            hero.classList.add('is-active');
            if (video && allowVideo) {
              if (!video.src) {                       // load only once, only when needed
                video.src = video.getAttribute('data-src');
              }
              var p = video.play();
              if (p && p.then) p.then(function () { video.classList.add('is-playing'); }).catch(function () {});
              else video.classList.add('is-playing');
            }
          } else if (video && !video.paused) {
            video.pause();                            // save CPU/battery when off-screen
          }
        });
      }, { threshold: 0.25 });

      io.observe(hero);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initDrawer();
    initCarousels();
    initHero();
    initQty();
    initGallery();
    initVariants();
    initAddToCart();
    initTabs();
    initFilterDrawer();
    initRecentlyViewed();
    initVideoHero();
  });
})();
